import { render, staticRenderFns } from "./VehicleNumber.vue?vue&type=template&id=3b84d98d&"
import script from "./VehicleNumber.vue?vue&type=script&lang=js&"
export * from "./VehicleNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports